import { StyledDrawerBody, StyledDrawerContainer } from 'baseui/drawer'
import { styled, withStyle } from 'parkdepot-shared/theme'

export const DrawerBody = withStyle(StyledDrawerBody, ({ $theme }) => ({
    margin: `5.6rem ${$theme.sizing.scale700} 4rem`
}))

export const DrawerContainer = withStyle(StyledDrawerContainer, ({ $theme }) => ({
    borderTopLeftRadius: '14px',
    borderTopRightRadius: '14px',

    [$theme.mediaQuery.large]: {
        width: '480px',
        left: '50%',
        transform: 'translateX(-50%)',
        marginBottom: '4px'
    }
}))

export const CloseContainer = styled('div', ({ $theme }) => ({
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    position: 'absolute',
    top: '2rem',
    left: '2rem',
    fontSize: '1.6rem'
}))
